export enum MediaSubscriptionStatusEnum {
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED',
    STOPPED = 'STOPPED',
    MODERATED = 'MODERATED',
    STAND_BY = 'STAND_BY'
}
